import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layouts/MainLayout';
import StatsCard from '../../components/admin/StatsCard';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { useAuth } from '../../hooks/useAuth';
import { theme } from '../../config/theme';
import { PackageIcon, ShoppingCartIcon, HeartIcon, UsersIcon } from '../../components/icons/Icons';
import { orderService } from '../../services/order.service';

const CustomerDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await orderService.getDashboardStats();
        setStats(response.data?.data || null);
      } catch (error) {
        console.error('Failed to fetch dashboard stats:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) return <MainLayout><LoadingSpinner fullScreen /></MainLayout>;

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl }}>
        <h1 style={{
          fontSize: theme.typography.fontSize['3xl'],
          fontWeight: theme.typography.fontWeight.bold,
          marginBottom: theme.spacing.xl,
        }}>
          Welcome back, {user?.first_name}!
        </h1>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: theme.spacing.lg,
          marginBottom: theme.spacing.xl,
        }}>
          <StatsCard
            title="My Orders"
            value={stats?.totalOrders ?? 0}
            icon={<PackageIcon size={32} />}
            onClick={() => navigate('/orders')}
          />
          <StatsCard
            title="Cart Items"
            value={stats?.totalCartItems ?? 0}
            icon={<ShoppingCartIcon size={32} />}
            onClick={() => navigate('/cart')}
          />
          <StatsCard
            title="Wishlist"
            value={stats?.totalWishlistItems ?? 0}
            icon={<HeartIcon size={32} />}
            onClick={() => navigate('/wishlist')}
          />
          <StatsCard
            title="Following"
            value={stats?.totalFollowing ?? 0}
            icon={<UsersIcon size={32} />}
            onClick={() => navigate('/following')}
          />
        </div>

        <Card title="Quick Actions">
          <div style={{ display: 'flex', gap: theme.spacing.md, flexWrap: 'wrap' }}>
            <Button variant="secondary" onClick={() => navigate('/orders')}>
              <PackageIcon size={20} />
              View Orders
            </Button>
            <Button variant="secondary" onClick={() => navigate('/following')}>
              <UsersIcon size={20} />
              View Following
            </Button>
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default CustomerDashboard;